export default "__VITE_ASSET__PlB67M6f__"